import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";

import { getClient, getClientVisits, listClientVisitLog } from "./api";

// Shared by the components that read these queries and by the client profile
// route's loader, which starts them while the route's chunk is still loading.
// One definition keeps the keys (and the visit log's paging) from drifting.

export const VISIT_LOG_LIMIT = 50;

export const clientQuery = (id: string) =>
  queryOptions({ queryKey: ["client", id], queryFn: () => getClient(id) });

export const clientVisitsQuery = (id: string) =>
  queryOptions({ queryKey: ["client-visits", id], queryFn: () => getClientVisits(id) });

export const clientVisitLogQuery = (id: string) =>
  infiniteQueryOptions({
    queryKey: ["client-visit-log", id],
    queryFn: ({ pageParam }) => listClientVisitLog(id, VISIT_LOG_LIMIT, pageParam),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      lastPage.has_more ? allPages.length * VISIT_LOG_LIMIT : undefined,
  });
